import React, { useState } from "react";
import "./AddModelForm.css"; 

const AddModelForm = ({ onClose, onmodelAdded }) => {
  const [entries, setEntries] = useState([
    { asset1_name: "", asset1_code: "", asset1_id: "" }
  ]);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Add another row
  const addEntry = () => {
    setEntries([...entries, { asset1_name: "", asset1_code: "", asset1_id: "" }]);
  };

  // Remove a row
  const removeEntry = (index) => {
    if (entries.length === 1) return; // Keep at least one
    setEntries(entries.filter((_, i) => i !== index));
  };

  // Handle input changes
  const handleChange = (index, field, value) => {
    const updated = [...entries];
    updated[index][field] = value;
    setEntries(updated);
  };

  // Handle form submission
 const handleSubmit = async (e) => {
  e.preventDefault();
  setError(null);

  const validationError = entries.some(entry => !entry.asset1_name.trim());

  if (validationError) {
    setError("All model entries must have a Model Name.");
    return;
  }

  if (submitting) return;
  setSubmitting(true);

  try {
    // Relative URL: Express serves the build and the API from the same origin.
    // (REACT_APP_API_URL in .env is http://localhost:5000, but the server listens on 4600.)
    const response = await fetch("/api/models/add-model", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(entries),
    });

    let data = {};
    try {
      data = await response.json();
    } catch {
      // Non-JSON response (e.g. HTML error page)
    }

    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}: Failed to add model.`);
    }

    alert("✅ Model added successfully!");
    setTimeout(() => {
      onmodelAdded(); 
      onClose(); 
    }, 300);
  } catch (error) {
    console.error("❌ Error adding model:", error.message);
    setError(error.message || "An error occurred.");
  } finally {
    setSubmitting(false);
  }
};

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>

        <h3>Add Models</h3>

        <form onSubmit={handleSubmit}>
          {entries.map((entry, index) => (
            <div key={index} className="entry-row" style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ddd', borderRadius: '5px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <h4 style={{ margin: 0 }}>Entry {index + 1}</h4>
                {entries.length > 1 && (
                  <button 
                    type="button" 
                    onClick={() => removeEntry(index)}
                    style={{ background: '#ff4444', color: 'white', border: 'none', padding: '5px 10px', cursor: 'pointer', borderRadius: '3px' }}
                  >
                    Remove
                  </button>
                )}
              </div>

              <div className="form-group">
                <label>Model Name:</label>
                <input 
                  type="text" 
                  value={entry.asset1_name} 
                  onChange={(e) => handleChange(index, 'asset1_name', e.target.value)} 
                  autoComplete="off"
                  placeholder="Enter model name"
                />
              </div>
              
              <div className="form-group">
                <label>Model Code:</label>
                <input 
                  type="text" 
                  value={entry.asset1_code} 
                  onChange={(e) => handleChange(index, 'asset1_code', e.target.value)} 
                  autoComplete="off"
                  placeholder="Enter model code (optional)"
                />
              </div>

              <div className="form-group">
                <label>Model Color:</label>
                <input 
                  type="text" 
                  value={entry.asset1_id} 
                  onChange={(e) => handleChange(index, 'asset1_id', e.target.value)} 
                  autoComplete="off"
                  placeholder="Enter model color (optional)"
                />
              </div>
            </div>
          ))}

          <button 
            type="button" 
            onClick={addEntry}
            style={{ marginBottom: '15px', background: '#4CAF50', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            + Add Another Model
          </button>
          
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Adding..." : "Add All Models"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddModelForm;